﻿import { useTranslation } from "react-i18next";
import TopBar from "@/pages/home/components/TopBar";
import Header from "@/pages/home/components/Header";
import Footer from "@/pages/home/components/Footer";
import StickyMobile from "@/pages/home/components/StickyMobile";
import Breadcrumb from "./components/Breadcrumb";
import HeroAbout from "./components/HeroAbout";
import OnsVerhaal from "./components/OnsVerhaal";
import OnzeWaarden from "./components/OnzeWaarden";
import OnsTeam from "./components/OnsTeam";
import Kerngegevens from "./components/Kerngegevens";
import WerkwijzeAbout from "./components/WerkwijzeAbout";
import Testimonials from "./components/Testimonials";
import CTABannerAbout from "./components/CTABannerAbout";

function SchemaMarkup() {
  const aboutSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "Wie zijn wij?",
    url: "https://ramen-repair-eindhoven.nl/wie-zijn-wij/",
    mainEntity: {
      "@type": "Organization",
      name: "Ramen Repair Eindhoven",
      url: "https://ramen-repair-eindhoven.nl/",
      telephone: "+31407987470",
      email: "info@ramen-repair-eindhoven.nl",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Eindhoven",
        addressRegion: "Noord-Brabant",
        addressCountry: "NL",
      },
      areaServed: {
        "@type": "City",
        name: "Eindhoven",
      },
    },
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://ramen-repair-eindhoven.nl/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Over ons",
        item: "https://ramen-repair-eindhoven.nl/wie-zijn-wij/",
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
    </>
  );
}

export default function WieZijnWij() {
  const { t } = useTranslation("wie-zijn-wij");

  return (
    <main className="bg-white min-h-screen">
      <title>{t("seo.title", { defaultValue: "Over ons | Ramen Repair Eindhoven — uw lokale kozijnspecialist" })}</title>
      <meta name="description" content={t("seo.description", { defaultValue: "Maak kennis met Ramen Repair Eindhoven: lokale specialist in kozijn-, raam- en schuifpuireparatie. 10 jaar garantie. Bel 040 798 7470." })} />
      <meta property="og:title" content={t("seo.title", { defaultValue: "Over ons | Ramen Repair Eindhoven — uw lokale kozijnspecialist" })} />
      <meta property="og:description" content={t("seo.description", { defaultValue: "Maak kennis met Ramen Repair Eindhoven: lokale specialist in kozijn-, raam- en schuifpuireparatie. 10 jaar garantie. Bel 040 798 7470." })} />
      <meta property="og:locale" content="nl_NL" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://ramen-repair-eindhoven.nl/wie-zijn-wij/" />
      <meta property="og:image" content="/og/og-home.jpg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Ramen Repair Eindhoven - kozijn en raamreparatie" />
      <link rel="canonical" href="https://ramen-repair-eindhoven.nl/wie-zijn-wij/" />
      <link rel="alternate" hreflang="nl-NL" href="https://ramen-repair-eindhoven.nl/wie-zijn-wij/" />
      <link rel="alternate" hreflang="x-default" href="https://ramen-repair-eindhoven.nl/wie-zijn-wij/" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t("seo.title", { defaultValue: "Over ons | Ramen Repair Eindhoven — uw lokale kozijnspecialist" })} />
      <meta name="twitter:description" content={t("seo.description", { defaultValue: "Maak kennis met Ramen Repair Eindhoven: lokale specialist in kozijn-, raam- en schuifpuireparatie. 10 jaar garantie. Bel 040 798 7470." })} />
      <meta name="twitter:image" content="/og/og-home.jpg" />
      <SchemaMarkup />
      <TopBar />
      <Header />
      <Breadcrumb />
      <HeroAbout />
      <OnsVerhaal />
      <OnzeWaarden />
      <OnsTeam />
      <Kerngegevens />
      <WerkwijzeAbout />
      <Testimonials />
      <CTABannerAbout />
      <Footer />
      <StickyMobile />
    </main>
  );
}